import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-parent',
  templateUrl: './parent.component.html',
  styleUrls: ['./parent.component.css'],
})
export class ParentComponent {
  @Input() missingQuestionUuids: string[] = [];
  @Input() isMissing = false;
  @Output() answered = new EventEmitter<string>();
  @Input() question!: Question;
  @Input() index!: number;
  @Output() answerSelected = new EventEmitter<{
    questionUuid: string;
    answerValues?: string[];
    otherValue?: string | Record<string, string>;
  }>();

  handleChildAnswer(event: {
    questionUuid: string;
    answerValue?:
      | string
      | { multiple: string; confidence: string }
      | { choice: string; other?: string };
    answerValues?: string[];
    otherValue?: string | Record<string, string>;
  }): void {
    this.answerSelected.emit(event);
    this.answered.emit(event.questionUuid);
  }
}
